import { useQuery } from "react-query";
import { getEmailSettings } from "../services/user/EmailSettings";
import { key_EmailSetings } from "../utils/constants";

export const useEmailSettings = (options:any= null) =>
  useQuery(
    [key_EmailSetings,key_EmailSetings],
    () => getEmailSettings(),
        options?{...options}:{}

  );